import React, { useEffect, useState } from "react";
import { Box, Container, Typography, useMediaQuery, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid2";
import "./ProjectsPage.css";
import ToggleCardComponent from "../../Components/CardComponents/ToggleCardComponent";
import NumberdItemComponent from "../../Components/NumberdItemComponent/NumberdItemComponent";
import ImageSelectorComponent from "../../Components/ImageSelectorComponent/ImageSelectorComponent";
import { getProjects, MEDIA_BASE_URL } from "../../Services/api";
import LoaderComponent from "../../Components/LoaderComponent/LoaderComponent";
import ExpandableText from "../../Components/ExpandableText/ExpandableText";
import VerticalLegendComponent from "../../Components/VerticalLegendComponent/VerticalLegendComponent";
import HorizontalLegendComponent from "../../Components/HorizontalLegendComponent/HorizontalLegendComponent";

interface Props { }

const ProjectsPage = (props: Props) => {
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    document.title = "תשתיות לישראל";

    getProjects()
      .then((projectData) => {
        setProjects(projectData);
        setFilteredProjects(projectData);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || "Unknown error");
      })
      .finally(() => { });

    const resetFocus = document.getElementById("reset-focus");
    if (resetFocus) resetFocus.focus();
  }, []);

  if (loading) return <LoaderComponent />;
  // if (error)   return <p>Error: {error}</p>;

  const onChangeFilter = (filterKey: string) => {
    if (filterKey === "") {
      setFilteredProjects(projects);
    } else {
      const filteredArr = projects.filter((project: any) => project.industry === filterKey);
      setFilteredProjects(filteredArr);
    }
  };

  return (
    <Container maxWidth="xl" sx={{ mb: "5rem" }}>
      <Box display="flex" justifyContent="center" paddingBlockStart={4} paddingBlockEnd={4}>
        <Typography variant={"h1"} className="title">
          עשרת מיזמי התשתית הגדולים
        </Typography>
      </Box>

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <img
            style={{ maxHeight: "450px", width: "100%", objectFit: "cover" }}
            className="rounded responsive-image"
            alt=""
            src="/images/projectPageImg.png"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <div className="greyTextBlock">
            <ExpandableText maxHeight={250}>
              <Typography textAlign={"justify"} mb={3} color="#0C3768">
                באתר זה תוכלו לעקוב אחר ההתקדמות של עשרת מיזמי התשתית החשובים בישראל – בתחומי התחבורה, האנרגיה והפסולת, זאת בהתאם לחוק לקידום תשתיות
                לאומיות, שמחייב לפרסם לציבור את לוחות הזמנים של המיזמים – משלב התכנון ועד השלמת המיזם.
              </Typography>
              <Typography fontWeight={700} color="#0C3768">
                באתר תוכלו למצוא:
              </Typography>
              <NumberdItemComponent />
              <Typography color="#0C3768">
                לוחות הזמנים מוצגים כפי שפורסמו על ידי גופי הביצוע, ומשרד ראש הממשלה אינו אחראי לנכונותם. ייתכנו שינויים בלוחות הזמנים.
              </Typography>
            </ExpandableText>
          </div>
        </Grid>
      </Grid>

      <Box display="flex" justifyContent="center" paddingBlockStart={4} paddingBlockEnd={4}>
        <Typography variant={"h2"} className="subtitle">
          מיזמים
        </Typography>
      </Box>
      <ImageSelectorComponent onChangeFilter={onChangeFilter} />

      {isMobile ? (
        <Box sx={{ marginTop: 5 }}>
          <VerticalLegendComponent />
        </Box>
      ) : (
        <Box display={"flex"} marginTop={"50px"} alignItems={"center"} justifyContent={"center"}>
          <HorizontalLegendComponent />
        </Box>
      )}

      {filteredProjects.length > 0 ? (
        <Grid id={"content"} container spacing={3}>
          {filteredProjects.map((project: any, index: number) => (
            <Grid
              key={index}
              size={{
                xs: 12,
                sm: 6,
                md: 4,
                lg: 4,
                xl: 3,
              }}
              marginTop="3rem"
              display="flex"
              justifyContent="center"
            >
              <ToggleCardComponent
                imgPath={`${MEDIA_BASE_URL}/${project.image_url}`}
                data={project}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <div>
          <Typography fontWeight={700} display={"flex"} justifyContent={"center"} py={10}>
            לא נמצאו פרויקטים בתחום זה.
          </Typography>
        </div>
      )}
    </Container>
  );
};

export default ProjectsPage;
